<!-- OpenIndicator.vue -->
<template>
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.85449 0C1.22168 0 0.905273 0.773438 1.3623 1.23047L5.8623 5.73047C6.14355 6.01172 6.60059 6.01172 6.88184 5.73047L11.3818 1.23047C11.8389 0.773438 11.5225 0 10.8896 0H1.85449Z" fill="#131313"/>
    </svg>
</template>
<script>
    export default {
        name: "OpenIndicator"
    }
</script>



// WEBPACK FOOTER //
// src/local-components/helpers/OpenIndicator.vue